<svg class="w-full" viewBox="0 0 330 271" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g class="">
    <path d="M188 90.9256L339 74L339 122L188 105.074L188 90.9256Z" fill="#DFE3F9" />
    <path d="M171.574 122.5L188.5 273.5L140.5 273.5L157.426 122.5L171.574 122.5Z" fill="#DFE3F9" />
    <path d="M139 105.074L-12 122L-12 74L139 90.9256L139 105.074Z" fill="#DFE3F9" />
    <path d="M157.426 73.5L140.5 -77.5L188.5 -77.5L171.574 73.5L157.426 73.5Z" fill="#DFE3F9" />
    <path
      d="M158.377 122.755L78.545 294.879L36.9758 270.879L146.124 115.681L158.377 122.755Z"
      fill="#DFE3F9"
    />
    <path
      d="M170.623 73.245L231.465 -65.9876L273.034 -41.9876L182.876 80.3194L170.623 73.245Z"
      fill="#DFE3F9"
    />
    <path
      d="M146.819 116.377L-6.34662 224.351L-30.3466 182.782L139.745 104.124L146.819 116.377Z"
      fill="#DFE3F9"
    />
    <path
      d="M182.181 79.623L325.745 -22.8079L349.745 18.7613L189.255 91.8762L182.181 79.623Z"
      fill="#DFE3F9"
    />
    <path
      d="M139.745 91.8765L-18.7389 19.9198L5.26113 -21.6494L146.819 79.6233L139.745 91.8765Z"
      fill="#DFE3F9"
    />
    <path
      d="M189.255 104.123L357.419 181.669L333.419 223.238L182.181 116.377L189.255 104.123Z"
      fill="#DFE3F9"
    />
    <path
      d="M146.123 80.3194L55.965 -41.9876L97.5342 -65.9876L158.376 73.245L146.123 80.3194Z"
      fill="#DFE3F9"
    />
    <path
      d="M182.877 115.681L273.035 237.988L231.466 261.988L170.624 122.755L182.877 115.681Z"
      fill="#DFE3F9"
    />
  </g>
  <!-- <path -->
  <!-- 	d="M-1 15C-1 6.16344 6.16344 -1 15 -1H315C323.837 -1 331 6.16344 331 15V271H-1V15Z" -->
  <!-- 	fill="url(#paint0_radial_1_67)" -->
  <!-- /> -->
  <rect x="0" y="0" width="100%" height="271" fill="url(#paint0_radial_1_67)" />
  <defs>
    <radialGradient
      id="paint0_radial_1_67"
      cx="0"
      cy="0"
      r="1"
      gradientUnits="userSpaceOnUse"
      gradientTransform="translate(165 135) rotate(-90) scale(136 205.999)"
    >
      <stop stop-color="#F4F5F9" stop-opacity="0" />
      <stop offset="1" stop-color="#F4F5F9" />
    </radialGradient>
  </defs>
</svg>

<style>
  @keyframes --spin {
    to {
      transform: rotate(360deg);
    }
  }

  /* .--animate-spin {
    animation: --spin 20s linear infinite;
    transform-origin: 50% 35%;
  } */
</style>
